import { INSTAGRAM_QUEUE } from "@/lib/instagramQueue";

export const InstagramQueueFilters = ({ value, counts, disabled, onChange }) => (
    <nav aria-label="Instagram post status filters" data-testid="instagram-draft-filter" className="mt-6 grid scroll-mt-28 scroll-mb-28 grid-cols-2 gap-x-3 border-b border-white/10 sm:grid-cols-3 lg:grid-cols-6">
        {INSTAGRAM_QUEUE.map(({ id, label, color }) => (
            <button type="button" key={id} onClick={() => onChange(id)} disabled={disabled} aria-pressed={value === id}
                data-testid={`instagram-filter-${id.replaceAll("_", "-")}`}
                className={`min-w-0 scroll-mt-28 scroll-mb-28 border-b-2 px-2 py-4 text-left transition-colors hover:bg-white/5 disabled:opacity-50 ${value === id ? "border-red-500 bg-white/5" : "border-transparent"}`}>
                <span className={`block min-h-10 text-xs font-semibold ${value === id ? "text-white" : color}`}>{label}</span>
                <span className="mt-1 block font-display text-xl font-bold text-white" data-testid={`instagram-count-${id.replaceAll("_", "-")}`}>{counts[id] ?? 0}</span>
            </button>
        ))}
    </nav>
);